import { render } from "./flight-icon.vue?vue&type=template&id=5ab0d052"
import script from "./flight-icon.vue?vue&type=script&lang=js"
export * from "./flight-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__